import { BookingAuthority } from "../../Services/BookingEntities";
import { SetErrorMessages } from "../Utils/CommonHelpers";
import { ErrorResult } from "../Utils/ErrorEntities";
import { Dispatch } from "../Dispatch";
import { LogBookingCreation, LogBookingCreationInGA4 } from "../Booking/LogBookingCreation";
import { BuildBookingRequestV2 } from "./BuildBookingRequestV2";
import { LoadNewOdrdTripId } from "./LoadNewOdrdTripId";
import { ICreateBooking } from "./ICreateBooking";
import { LoadMyRecentTrips, TrackBookingHelper } from "./BookingLoaders";
import { ServiceOfferingsService } from "../../Services/ServiceOfferings";

/** Create Booking using the V2 API endpoint (ServiceOfferings-based booking path) */
export class CreateBookingV2 implements ICreateBooking {

    /** The booking ID, defined when the API call succeeds */
    NewBookingId: BookingAuthority | null = null;

    /** The error, defined when the API call fails */
    Error: ErrorResult | null = null;

    constructor(readonly withSmsVerification: boolean) { }

    /** Create a booking by transforming the model to V2 entity and calling ServiceOfferings service */
    async CreateBooking(): Promise<boolean> {
        const createBookingEntity = BuildBookingRequestV2(this.withSmsVerification);
        const isFixedFareBooking = !!createBookingEntity.Payment.IsFixedFare;

        var serviceResult = await ServiceOfferingsService.CreateBookingV2(createBookingEntity);
        Dispatch.UILogicControl.BookingFormApiEnd();

        if (serviceResult.isSuccess) {
            // ServiceResult unwraps the V2 API response, so value directly contains { bookingId, hashCode }
            this.NewBookingId = serviceResult.value;
            LoadNewOdrdTripId();
            LogBookingCreation(isFixedFareBooking);
            LogBookingCreationInGA4(this.NewBookingId.bookingId);
            return true;
        }
        else {
            this.Error = SetErrorMessages(serviceResult);
            return false;
        }
    }

    /** Refresh Tracking and Recent Trips data based on the booking */
    async ProcessBooking(): Promise<void> {
        await TrackBookingHelper(this.NewBookingId!.bookingId, this.NewBookingId!.hashCode);

        // Refresh the list of recent trips along with the newly created booking
        LoadMyRecentTrips();
    }

    /** Returns the ErrorResult */ 
    GetError(): ErrorResult {
        return this.Error!;
    }
}
